import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ViewPackageDetailsService } from './view-package-details.service';
import { WebSocketService } from '../web-socket.service';
import { Subscription } from 'rxjs';
import { ViewAndUpdateConfig } from "../configuration/view-and-update-config/viewAndUpdateConfig.service";
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-view-package-details',
  templateUrl: './view-package-details.component.html',
  styleUrls: ['./view-package-details.component.sass']
})
export class ViewPackageDetailsComponent implements OnInit {
  packageId:any;
  packageData:any;
  acceptPackageSubscription: Subscription;
  messages:any
  messageReceived:boolean=false;
  regenerateVisible:boolean=false;
  showNotification:boolean;



  vehicleRunning:boolean=true
  timeout:boolean=false
  packageAccepted:boolean=false

  constructor(public activatedRoute: ActivatedRoute,
    private router: Router,
    private viewDetailService :ViewPackageDetailsService,
    private spinner : NgxSpinnerService,
    private toastr:ToastrService,
    private webSocketService : WebSocketService,
    private packageConfigService: ViewAndUpdateConfig
  ) { }

  ngOnInit(): void {
    // this.webSocketService.connect()

      // this.getSocketData()
    


    this.packageId=this.activatedRoute.snapshot.queryParams.id;
    // console.log(this.packageId)
    this.getPackageConfig()
    // this.getPackageById()
  }
  
  // acceptPackage() { 
  //   let sendSringMsg=JSON.stringify(this.packageData)
  //   console.log("sendSringMsg",sendSringMsg)
  //   // this.webSocketService.sendAcceptPackage(sendSringMsg);
  //   this.showNotification=true

  //   this.vehicleRunning=true;
  //   this.timeout=false;
  //   this.packageAccepted=false;
  //   setTimeout(() => this.closeNotificationPopUp(), 60000);
  // }
//   closeNotificationPopUp() {
//     // Check if packageAccepted is false before sending the close notification
//     if (!this.packageAccepted) {
//         console.log("closeNotification message sent!");
//         // this.webSocketService.sendAcceptPackage("closeNotification");
//         this.timeout=true;
//         this.vehicleRunning=false;
//         this.packageAccepted=false;
//     } else {
//         console.log("Close notification not sent because packageAccepted is true");
//     }
// }

socketData:any

  // getSocketData(){
  //   this.webSocketService.connect()
  //   this.webSocketService.onAcceptPackage().subscribe((result:any)=>{
  //     console.log("socketDataSTR", result)
  //     if(result.message=="start"){
  //       console.log("start msg")
  //     }else if(result.message.includes('packageId')){
  //       this.socketData=JSON.parse(result.message)
  //       console.log("socketData", this.socketData)
  //       let socketPkgID=this.socketData.packageId
  //       console.log( "socketPkgID", socketPkgID, "apiPkgID", this.pkgID)
  //       if(this.pkgID==socketPkgID){
  //         console.log("PkgID Match")
  //         if(result.message.includes('driverId')){
  //           console.log("driver accepted package", this.socketData.driverId)
  //           this.timeout=false;
  //           this.vehicleRunning=false;
  //           this.packageAccepted=true;
  //         }
  //       }else if(result.message=="closeNotification"){
  //         console.log("closeNotification 1min", result)
  //       }
  //       } 
  //   })
  // }
  packageConfig:any
  getPackageConfig(){
    this.packageConfigService.getPackageConfig().subscribe((result:any)=>{
      if(result.statusCode==200){
        this.packageConfig=result.data
        console.log("package config", this.packageConfig)
        // this.toastr.success(result.message)
        this.getPackageById()
      }
      else(console.log("Error in Package Config Api"), this.toastr.error(result.message),this.getPackageById())
    })
  }

pkgID:any
driverAmount:any
  getPackageById(){
      this.spinner.show();
      let data = {
        "id" : this.packageId
      }
      this.viewDetailService.getPackageById(data).subscribe((result:any)=>{
        if(result.statusCode == 200){
          this.spinner.hide()
          this.packageData = result.data;
          this.pkgID=this.packageData.packageID
          // console.log("PackageID",this.pkgID)
          const tripFareWithoutGSTNumber = parseFloat(this.packageData.tripFareWithoutGST);
          const helperWithoutGSTNumber = parseFloat(this.packageData.helperWithoutGST);
          // console.log("HelpertDS", this.packageConfig.helperTDS)
          this.driverAmount=tripFareWithoutGSTNumber + helperWithoutGSTNumber -((tripFareWithoutGSTNumber + helperWithoutGSTNumber)*this.packageConfig.helperTDS)/100
          // console.log("DriverAmount", this.driverAmount)
          console.log(this.packageData)
        }else{
          this.spinner.hide()
          this.toastr.error(result.message);
        }
      })
  }
  
  back(){
    this.router.navigateByUrl('dashboard/package')
  }

  packageimageUrl:any;
  vehicleimageUrl:any;
  onNavigate(value , imagePath){
    if(value == 'PACKAGE'){
      if(imagePath){
        this.packageimageUrl = imagePath
      }else{
        this.packageimageUrl = ''
        this.toastr.error('Image Not Found')
      }
    }else if(value == 'VEHICLE'){
      if(imagePath){
        this.vehicleimageUrl = imagePath
      }else{
        this.vehicleimageUrl = ''
        this.toastr.error('Image Not Found')
      }
    }
   
}
// open vehicle running model
isModalOpen = false;
openModal() {
  this.isModalOpen = true;
}
closeModal() {
  this.isModalOpen = false;
}

exportToExcel() {
  const exportData: any[] = [];
  const data = this.packageData
  // Add empty row between sections
  exportData.push({});
  // Add Package Info fields
  exportData.push({ Category: 'Package Info', Fields: 'Package ID', Details: data?.packageID });
  exportData.push({ Category: '', Fields: 'Package Created At',Details: new Date(data?.timestamp * 1000).toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true  // Use 24-hour format
  }).replace(',', '') // Remove the comma between date and time
});
  exportData.push({ Category: '', Fields: 'Pick up Address', Details: data?.fromAddress });
  exportData.push({ Category: '', Fields: 'Deliver Address', Details: data?.toAddress });
  exportData.push({ Category: '', Fields: 'Required Vehicle Type', Details: data?.vehicleType });
  exportData.push({ Category: '', Fields: 'Distance', Details: ` ${data?.distance} KM` });
  exportData.push({ Category: '', Fields: 'City', Details: data?.city });
  exportData.push({ Category: '', Fields: 'Sender Name', Details: data?.senderName });
  exportData.push({ Category: '', Fields: 'Sender Mobile', Details: data?.senderMobile });
  exportData.push({ Category: '', Fields: 'Sender Email', Details: data?.senderEmail });
  exportData.push({ Category: '', Fields: 'Reciever Name', Details: data?.receiverName });
  exportData.push({ Category: '', Fields: 'Reciever Mobile', Details: data?.receiverMobile });
  exportData.push({ Category: '', Fields: 'Package Description', Details: data?.goodsDescription });
  exportData.push({ Category: '', Fields: 'Package Dimentions', Details: data?.goodsDimension });
  exportData.push({ Category: '', Fields: 'Package Weight In Kg', Details: data?.goodsWeightKg });
  
  // Add empty row between sections
  exportData.push({});

  // Payment Details
  exportData.push({ Category: 'Payment Details', Fields: 'Payment Method', Details: data.paymentDetails?.paymentMethod });
  exportData.push({ Category: '', Fields: 'Amount', Details: data.paymentDetails?.totalAmount });
  exportData.push({ Category: '', Fields: 'Payment Status', Details: data.paymentDetails?.status ==1? 'Done' : 'Pending' });
  
  // Add empty row between sections
  exportData.push({});
  
  // Driver Details
  exportData.push({ Category: 'Driver Details', Fields: 'Driver Name', Details: data?.driverName});
  exportData.push({ Category: '', Fields: 'Driver Mobile', Details: data.driverMobile });
  exportData.push({ Category: '', Fields: 'Driver Vehicle Number', Details: data.driverVehicleNumber});
  exportData.push({ Category: '', Fields: 'Amount To Driver', Details:this.driverAmount });

  // Create a worksheet
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

  // Create a workbook
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Items');

  // Export the workbook with packageID
  const packageId = (data?.packageID || 'UnknownPackageID').toUpperCase(); 
  XLSX.writeFile(wb, `Order_${packageId}.xlsx`);
}

routeTrackPackage(){
  this.router.navigate(['dashboard/trackPackage'], { queryParams : { id: this.packageData._id } });
}
}
